import React, { useCallback, useEffect } from "react";
import MainHeader from "../../Components/Header/MainHeader";
import MainFooter from "../../Components/Footer/MainFooter";
import { db } from "../../Database/RekebishaAdmin/config";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ImageOff, MapPin, Star, User } from "lucide-react";
import ContactGate from "../../Components/ContactGate";
import ReviewSection from "../../Components/ReviewSection";

export default function SharedPortfolio(props) {
  const { sharedId } = useParams();

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [phonenumber, setPhoneNumber] = useState(0);
  const [professionalbody, setProfessionalBody] = useState("");
  const [profession, setProfession] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [avatarurl, setAvatarUrl] = useState("");
  const [rating, setRating] = useState(0);
  const [subcounty, setSubCounty] = useState("");
  const [competenceRating, setCompetenceRating] = useState(null);
  const [certificationRating, setCertificationRating] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await db
        .collection("FundiAppUsers")
        .doc(sharedId)
        .collection("Posts")
        .get();

      // Two generations of writer exist: this website only ever wrote images
      // (imageUrl); the fundi's own app can write images or video (mediaUrl +
      // mediaType). Every item is normalised so the grid below doesn't need to care
      // which one wrote it.
      const items = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          title: data.title,
          mediaUrl: data.mediaUrl || data.imageUrl,
          mediaType: data.mediaType === "video" ? "video" : "image",
        };
      });
      setPortfolioItems(items);
    };
    fetchData();
  }, [sharedId]);

  /*Get the users Information*/
  const getUserDetails = useCallback(async () => {
    try {
      const doc = await db.collection("FundiAppUsers").doc(sharedId).get();

      if (doc.exists) {
        const data = doc.data();
        const firstname = data.firstname;
        const lastname = data.lastname;
        const phonenumber = data.phonenumber;
        const professionalBody = data.professionalbody;
        const profession = data.profession;
        const email = data.email;
        const address = data.countylocation;
        const avatarurl = data.profileimage;
        const rating = data.competenceRating;
        const subcounty = data.subcounty;
        const competenceRating = data.competenceRating;
        const certificationRating = data.certificationRating;

        setAvatarUrl(avatarurl);
        setFirstName(firstname);
        setLastName(lastname);
        setProfession(profession);
        setPhoneNumber(phonenumber);
        setProfessionalBody(professionalBody);
        setEmail(email);
        setAddress(address);
        setRating(rating);
        setSubCounty(subcounty);
        setCompetenceRating(competenceRating);
        setCertificationRating(certificationRating);

        if (typeof window.fbq === "function") {
          window.fbq("track", "ViewContent", {
            content_type: "fundi_profile",
            content_ids: [sharedId],
            content_name: [firstname, lastname].filter(Boolean).join(" "),
          });
        }
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error getting user details:", error);
    }
  }, [sharedId]);
  useEffect(() => {
    getUserDetails();
  }, [getUserDetails]);

  const Stars = ({ value }) => {
    const filled = Math.round(Number(value) || 0);
    return (
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`w-4 h-4 ${i < filled ? 'text-brandgreen fill-current' : 'text-gray-300'}`}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <MainHeader />

      {/* Breadcrumb */}
      <div className="bg-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link
            to="/find-fundi"
            className="inline-flex items-center text-gray-300 hover:text-brandgreen font-semibold transition-colors duration-300"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back To All Fundis
          </Link>
        </div>
      </div>

      <div className="flex-1 bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Profile Sidebar */}
            <div className="w-full lg:w-80 shrink-0">
              <div className="lg:sticky lg:top-8 space-y-6">
                <div className="bg-white rounded-2xl border border-gray-100 shadow-lg p-8 flex flex-col items-center text-center">
                  {avatarurl ? (
                    <img
                      src={avatarurl}
                      alt={firstname && lastname ? `${firstname} ${lastname}` : 'Profile'}
                      className="h-28 w-28 rounded-full object-cover bg-gray-50 ring-4 ring-brandgreen/10 mb-5"
                    />
                  ) : (
                    <div className="h-28 w-28 rounded-full bg-navy flex items-center justify-center mb-5">
                      <User className="w-12 h-12 text-white" />
                    </div>
                  )}

                  {firstname && lastname ? (
                    <h1 className="text-2xl font-bold text-navy capitalize mb-3">{`${firstname} ${lastname}`}</h1>
                  ) : (
                    <div className="h-5 bg-gray-200 rounded-full w-40 mb-3 animate-pulse"></div>
                  )}

                  {profession ? (
                    <span className="text-xs bg-brandgreen/10 text-brandgreen py-1.5 px-3 rounded-full font-semibold capitalize mb-3">
                      {profession}
                    </span>
                  ) : (
                    <div className="h-4 bg-gray-200 rounded-full w-32 mb-3 animate-pulse"></div>
                  )}

                  {professionalbody ? (
                    <p className="text-sm text-gray-600 capitalize mb-4">{professionalbody}</p>
                  ) : (
                    <div className="h-3 bg-gray-200 rounded-full w-36 mb-4 animate-pulse"></div>
                  )}

                  <Stars value={rating} />
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-lg p-6">
                  <h2 className="text-xs font-bold text-navy uppercase tracking-wide mb-4">
                    Rating Details
                  </h2>
                  <div className="space-y-3 text-sm text-gray-600">
                    <div className="flex items-center justify-between gap-2">
                      <span>Certification</span>
                      <Stars value={certificationRating} />
                    </div>
                    <div className="flex items-center justify-between gap-2">
                      <span>Competence</span>
                      <Stars value={competenceRating} />
                    </div>
                    <div className="flex items-center justify-between gap-2">
                      <span>Courtesy</span>
                      <Stars value={0} />
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-lg p-6">
                  <h2 className="text-xs font-bold text-navy uppercase tracking-wide mb-4">
                    Contact Details
                  </h2>
                  <ContactGate
                    subjectType="handyman"
                    subjectId={sharedId}
                    name={firstname && lastname ? `${firstname} ${lastname}` : "this fundi"}
                    phone={phonenumber}
                    email={email}
                  />
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-lg p-6">
                  <h2 className="text-xs font-bold text-navy uppercase tracking-wide mb-4">Location</h2>
                  <div className="space-y-3 text-sm text-gray-600">
                    {address ? (
                      <div className="flex items-center gap-2 capitalize">
                        <MapPin className="w-4 h-4 text-brandgreen flex-shrink-0" />
                        <span>County: {address}</span>
                      </div>
                    ) : (
                      <div className="h-3 bg-gray-200 rounded-full w-36 animate-pulse"></div>
                    )}
                    {subcounty && (
                      <div className="flex items-center gap-2 capitalize">
                        <MapPin className="w-4 h-4 text-brandgreen flex-shrink-0" />
                        <span>Sub County: {subcounty}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Portfolio */}
            <div className="flex-1 min-w-0">
              <h2 className="text-2xl font-bold text-navy mb-6">Portfolio Of Work</h2>

              {portfolioItems.length !== 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                  {portfolioItems.map((item) =>
                    item.mediaType === "video" ? (
                      <div
                        key={item.id}
                        className="group relative rounded-2xl overflow-hidden block h-64 bg-navy"
                      >
                        <video
                          className="w-full h-full object-cover"
                          src={item.mediaUrl}
                          controls
                          preload="metadata"
                        />
                        <div className="absolute inset-x-0 bottom-0 bg-navy/80 px-4 py-3 pointer-events-none">
                          <h3 className="capitalize truncate text-white font-semibold">{item.title}</h3>
                        </div>
                      </div>
                    ) : (
                      <a
                        key={item.id}
                        href={item.mediaUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="group relative rounded-2xl overflow-hidden block h-64"
                      >
                        <img
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          src={item.mediaUrl}
                          alt={item.title || 'Portfolio work'}
                        />
                        <div className="absolute inset-x-0 bottom-0 bg-navy/80 px-4 py-3">
                          <h3 className="capitalize truncate text-white font-semibold">{item.title}</h3>
                        </div>
                      </a>
                    )
                  )}
                </div>
              ) : (
                <div className="flex flex-col items-center text-center gap-4 bg-white rounded-2xl border border-gray-100 shadow-sm py-20 px-6">
                  <div className="w-20 h-20 bg-brandgreen/10 rounded-full flex items-center justify-center">
                    <ImageOff className="w-10 h-10 text-brandgreen" />
                  </div>
                  <h3 className="text-xl font-bold text-navy">No Portfolio Items Yet</h3>
                  <p className="text-gray-600 max-w-sm">
                    This fundi has not uploaded any work samples yet. You can still reach out using the
                    contact details on the left.
                  </p>
                </div>
              )}

              <div className="mt-10">
                <ReviewSection
                  subjectType="handyman"
                  subjectId={sharedId}
                  subjectName={firstname && lastname ? `${firstname} ${lastname}` : "this fundi"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <MainFooter />
    </div>
  );
}
